export const getVerdictVariant = (v: string) => {
  const verdictMap = {
    MALICIOUS: 'red',
  };
  return verdictMap[v?.toUpperCase()] || 'neutral';
};

export const getNormalizedExtension = (fileName: string) => fileName.split('.').at(-1)?.toLowerCase() ?? '';

export const MDR_SOURCE_NAME = 'zscaler advanced detections';

export const checkIsMdrIncident = (sourceNames?: string[] | null): boolean =>
  sourceNames?.length === 1 && sourceNames[0]?.toLowerCase() === MDR_SOURCE_NAME;
